import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Activity, Building2, ClipboardList, FileText, Users, ShieldCheck, LogOut, Menu, X, Database, ChevronRight, Layers, UserCog, GitBranch, ScrollText, Upload, History } from "lucide-react";
import { api } from "../api";

export function Login({ onLogin, message = "" }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [latestVersion, setLatestVersion] = useState(null);

  useEffect(() => {
    let active = true;

    api.get("/system-releases/latest-version")
      .then(response => {
        if (active) {
          const version = response.data?.version;
          setLatestVersion(
            typeof version === "string" && /^[0-9]+(\.[0-9]+)*$/.test(version)
              ? version
              : null
          );
        }
      })
      .catch(() => {
        if (active) setLatestVersion(null);
      });

    return () => {
      active = false;
    };
  }, []);
  const submit = async e => {
    e.preventDefault();
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("token", r.data.token);
      onLogin(r.data.user);
    } catch (x) { setError(x.response?.data?.detail || "Accesso non riuscito"); }
  };
  return <main className="login-shell"><section className="login-panel"><div className="brand-mark"><Activity size={25}/><span>CENTRALE <b>118</b></span></div><div className="login-copy"><span className="eyebrow">ACCESSO RISERVATO · DEMO</span><h1>Supporto operativo<br/><em>in tempo reale.</em></h1><p>Un punto di accesso unico per strutture, disponibilità e procedure interne verificabili.</p></div><form onSubmit={submit} className="login-form"><label>Email<input data-testid="login-email-input" value={email} onChange={e=>setEmail(e.target.value)} type="email" required/></label><label>Password<input data-testid="login-password-input" value={password} onChange={e=>setPassword(e.target.value)} type="password" required/></label><NavLink to="/password-dimenticata" data-testid="login-forgot-password-link" style={{justifySelf:"end",fontSize:12,color:"var(--red)",textDecoration:"none"}}>Password dimenticata?</NavLink>{(error || message)&&<div data-testid="login-error" className="error">{error || message}</div>}<button data-testid="login-submit-button" className="primary-btn" type="submit">Accedi alla console <ChevronRight size={17}/></button></form></section><aside className="login-aside"><div className="signal-grid"><div><span>01</span><b>STRUTTURE</b><small>Disponibilità verificabili</small></div><div><span>02</span><b>PROCEDURE</b><small>Fonti sempre visibili</small></div><div><span>03</span><b>TRACCIABILITÀ</b><small>Audit operativo</small></div></div><div className="aside-foot"><span>● SISTEMA DEMO ATTIVO</span><span>{latestVersion ? `v${latestVersion} · 118 OPS` : "118 OPS"}</span></div></aside></main>;
}

export function Layout({ user, onLogout, children }) {
  const [open, setOpen] = useState(false);
    const permissions = user?.permissions || [];

  const can = permission =>
    permissions.includes(permission);

  const nav = [
  { to: "/", label: "Dashboard", icon: Activity },
  {
    to: "/strutture",
    label: "Ricerca strutture",
    icon: Building2,
    permission: "operative.facilities.read"
  },
  {
    to: "/procedure",
    label: "Procedure IA",
    icon: ClipboardList,
    permission: "operative.ai.use"
  },
  {
    to: "/algoritmi",
    label: "Algoritmi",
    icon: GitBranch,
    permission: "operative.algorithms.read"
  },
  { to: "/profilo", label: "Profilo", icon: UserCog },
].filter(item => !item.permission || can(item.permission));

  const admin = [
  {
    to: "/admin",
    label: "Panoramica",
    icon: Database,
    permission: "admin.dashboard.read"
  },
  {
    to: "/admin/strutture",
    label: "Strutture",
    icon: Building2,
    permission: "admin.facilities.read"
  },
  {
    to: "/admin/servizi",
    label: "Servizi",
    icon: Layers,
    permission: "admin.services.read"
  },
  {
    to: "/admin/algoritmi",
    label: "Gestione Algoritmi",
    icon: GitBranch,
    permission: "admin.algorithms.read"
  },
  {
    to: "/admin/documenti",
    label: "Documenti",
    icon: FileText,
    permission: "admin.documents.read"
  },
  {
    to: "/admin/utenti",
    label: "Utenti",
    icon: Users,
    permission: "admin.users.read"
  },
  {
    to: "/admin/ruoli",
    label: "Ruoli e permessi",
    icon: ShieldCheck,
    permission: "admin.roles.read"
  },
  {
    to: "/admin/android-updates",
    label: "Aggiornamenti Android",
    icon: Upload,
    permission: "admin.android_updates.read"
  },
  {
    to: "/admin/rilasci",
    label: "Gestione rilasci",
    icon: History,
    adminOnly: true
  },
  {
    to: "/admin/audit",
    label: "Audit log",
    icon: ScrollText,
    permission: "admin.audit.read"
  },
].filter(item => item.adminOnly ? user?.role === "admin" : can(item.permission));

  return <div className="app-layout"><aside className={open?"sidebar open":"sidebar"}><div className="side-brand"><div className="brand-symbol"><Activity size={20}/></div><div><b>118 / OPS</b><small>CONTROL ROOM</small></div><button className="icon-btn mobile-only" onClick={()=>setOpen(false)} data-testid="close-navigation-button"><X size={18}/></button></div><div className="operator-chip"><span className="status-dot"/><div><b>{user.name}</b><small>{user.role_name || user.role}</small></div></div><nav><span className="nav-label">OPERATIVO</span>{nav.map(({to,label,icon:Icon})=><NavLink data-testid={`nav-${label.toLowerCase().replaceAll(" ","-")}-link`} onClick={()=>setOpen(false)} key={to} to={to} end={to==="/"}><Icon size={17}/>{label}</NavLink>)}{admin.length>0&&<>
  <span className="nav-label admin-label">
    AMMINISTRAZIONE
  </span>

  {admin.map(({to,label,icon:Icon})=>
    <NavLink
      data-testid={`nav-${label.toLowerCase().replaceAll(" ","-")}-link`}
      onClick={()=>setOpen(false)}
      key={to}
      to={to}
    >
      <Icon size={17}/>
      {label}
    </NavLink>
  )}
</>}
</nav><div className="sidebar-bottom"><div className="privacy-note"><ShieldCheck size={16}/><span>Accesso protetto<br/><b>Sessione crittografata</b></span></div><button data-testid="logout-button" className="logout-btn" onClick={onLogout}><LogOut size={16}/> Esci</button></div></aside><button className="mobile-menu icon-btn" onClick={()=>setOpen(true)} data-testid="open-navigation-button"><Menu size={20}/></button><main className="main-content">{children}</main></div>;
}

export function Header({ kicker, title, subtitle, showStatus = true }) {
  return <header className="page-header"><div><span className="eyebrow">{kicker}</span><h1 data-testid="page-title">{title}</h1>{subtitle&&<p>{subtitle}</p>}</div>{showStatus && <div className="live-pill"><span className="status-dot"/> DATI DEMO <small>AGGIORNATI</small></div>}</header>;
}
